module.exports = __webpack_public_path__ + "img/af.e8963830.png";